import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, signal, SimpleChanges } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { PERMISSION_CONSTANT } from '../../../../../constants/permission';
import { ASSIGN_CLIENT_FORM_CONTROLS, CUSTOM_SAVE_BUTTON_CONFIG, noRecordFound } from './assign-timesheet.constant';
import { ClientStoreService } from '../../../../../state/modules/client/client-store.service';
import { groupBy } from 'lodash';
import { EmployeeStoreService } from '../../../../../state/modules/employee/employee-store.service';
import { EmployeeService } from '../../../../../state/modules/employee/services/employee.service';
import { of, Subscription } from 'rxjs';
import { PERMISSIONV2 } from '../../../../../constants/permissionv2/role-permission';
import { MasterService } from '../../../../../state/master/services/master.service';

@Component({
  standalone: false,
  selector: 'kt-assign-timesheet',
  templateUrl: './assign-timesheet.component.html',
  styleUrls: ['./assign-timesheet.component.scss']
})
export class AssignTimesheetComponent extends ModalBaseClass implements OnInit, OnDestroy {
  description = null;
  isModal = false;
  noRecordFound = noRecordFound;
  PermissionV2 = PERMISSIONV2
  loading = signal(false)

  /**
      * External inputs
      */
  @Input() options;
  @Input() set employeeData(value) {
    if (value) {
      this._employeeData = value;
      // this.setLoggedInUserProfile();
      if (this._employeeData && this._employeeData.employee_id && this.options && !this.options.showCancel) {
        // this.loading = true;
        setTimeout(() => {
          this.dispatchGetAssignLocationByEmployee(this._employeeData.employee_fk_user_id);
        }, 100);
      }
    }
  }

  @Input() set assignTimesheetForm(value) {
    this._assignTimesheetForm = value ? value : new UntypedFormGroup({ assignTimesheets: new UntypedFormArray([]) });
  }

  /**
 * External outputs
 */
  @Output() callback = new EventEmitter<any>();

  /**
   * Constants
   */
  formConstants = ASSIGN_CLIENT_FORM_CONTROLS;
  buttonConstants = CUSTOM_SAVE_BUTTON_CONFIG;
  _assignTimesheetForm: UntypedFormGroup;
  _employeeData = null;
  lookupOptions: any = {
    locations: {},
    client: [],
  };
  assignTimesheetData = [];
  previousSelectedIds = [];
  isLoggedInUserProfile = false;
  permissionConstant = PERMISSION_CONSTANT;
  subscriptions: Subscription[] = [];
  allClients = [];

  masterBusinessLabel = MasterService.masterBusinessLabel

  constructor(
    private ngbModal: NgbModal,
    public clientStoreService: ClientStoreService,
    public employeeService: EmployeeService,
    private employeeStoreService: EmployeeStoreService,
    private cdr: ChangeDetectorRef
  ) {
    super(ngbModal);
  }

  ngOnInit() {
    this.subscriptions.push(this.employeeService.refreshAssignTimesheet$.subscribe(data => {
      if (data && this._employeeData && this._employeeData.employee_fk_user_id) {
        this.clientGets();
        this._assignTimesheetForm = new UntypedFormGroup({ assignTimesheets: new UntypedFormArray([]) });
        if (this._employeeData && this._employeeData.employee_id && this.options && !this.options.showCancel) {
          setTimeout(() => {
            this.dispatchGetAssignLocationByEmployee(this._employeeData.employee_fk_user_id);
          }, 100);
        }
      }
    }));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.employeeData && changes.employeeData.currentValue) {
      if (changes.employeeData.currentValue.employee_fk_user_id) {
        this.clientGets();
      }
    }
  }

  clientGets() {
    this.subscriptions.push(this.employeeService.getAssignTimeSheetClient(this._employeeData.employee_fk_user_id).subscribe(res => {
      if (res.success && res.data.data.clients) {
        this.allClients = res.data.data.clients;
      }
    }));
  }

  saveAssignLocation() {
    if (this._assignTimesheetForm.invalid) {
      setTimeout(() => {
        this._assignTimesheetForm.markAllAsTouched();
      });

      return;
    }

    this.loading.set(true);
    const payload: any = {};
    payload.timesheet_employee_client_location_fk_employee_id = this._employeeData.employee_id;
    payload.timesheet_employee_client_location_fk_user_id = this._employeeData.employee_fk_user_id;
    payload.timesheetEmployeeClientLocationDatas = [];
    this._assignTimesheetForm.value.assignTimesheets.forEach(data => {
      data.location.forEach(location => {
        payload.timesheetEmployeeClientLocationDatas.push(
          {
            timesheet_employee_client_location_fk_client_id: data.client,
            timesheet_employee_client_location_fk_location_id: location
          }
        )
      });
    })

    this.subscriptions.push(this.employeeService.assignTimesheetSave(payload).subscribe(response => {
      this._assignTimesheetForm.markAsPristine();
      this.loading.set(false);
    }));
  }

  /**
   * Add new assign timesheet control
   */
  addAssignTimesheet() {
    this.getAssignTimesheetFormArray().push(new UntypedFormGroup({ employee_client_location_id: new UntypedFormControl(0) }));
    setTimeout(() => {
      this.setOptions();
    }, 10);
  }

  /**
   * To set drop down options
   */
  setOptions() {
    if (this._assignTimesheetForm.value && this._assignTimesheetForm.value.assignTimesheets) {
      const selectedClients: Array<any> = this._assignTimesheetForm.value.assignTimesheets.map(value => value.client);
      this._assignTimesheetForm.value.assignTimesheets.forEach((assignLocation, index) => {
        // All selected client except client at given index
        const filteredClient = selectedClients.filter((client, i) => i !== index);
        this.lookupOptions.client[index] = of(this.allClients.filter(client => !filteredClient.includes(client.client_id)));
      });
    };
  }

  getAssignTimesheetFormArray() {
    return this._assignTimesheetForm.controls.assignTimesheets as UntypedFormArray;
  }

  /**
   * To get the assignTimesheet formgroup at given assignTimesheetIndex
   * @param assignTimesheetIndex
   */
  getAssignTimesheet(assignTimesheetIndex: number): UntypedFormGroup {
    return this.getAssignTimesheetFormArray().controls[assignTimesheetIndex] as UntypedFormGroup;
  }

  /**
   * Handles client change event
   */
  clientChange(event, index) {

    this.setOptions();
    if (event && event.value) {
      this.dispatchClientLocation(event.value);
      this.getAssignTimesheetFormArray().controls[index].get('location').enable();
      this.getAssignTimesheetFormArray().controls[index].get('location').setValue(null);
    } else {
      this.getAssignTimesheetFormArray().controls[index].get('location').setValue(null);
      this.getAssignTimesheetFormArray().controls[index].get('location').disable();
    }
  }

  /**
   * Removes control at given index
   */
  removeAssignTimesheet(index) {
    this.getAssignTimesheetFormArray().removeAt(index);
    setTimeout(() => {
      this.setOptions();
    }, 10);
  }

  /**
 * Set the form for client location data
 */
  setAssignClientLocationData() {
    const formatedData = [];
    const groupByData = groupBy(this.assignTimesheetData, 'timesheet_employee_client_location_fk_client_id');
    Object.keys(groupByData).forEach(object => {
      const obj = { client: parseInt(object), location: groupByData[object].map(location => location.timesheet_employee_client_location_fk_location_id) };
      formatedData.push(obj);
    });
    // employeeData Input  Set Event multiple time call at that time multiple times added formArray Control so i added this if condition. if (formatedData.length > this.getAssignLocationFormArray().length)
    if (formatedData.length > this.getAssignTimesheetFormArray().length) {
      for (const val of formatedData) {
        this.addAssignTimesheet();
        setTimeout(() => {
          this.dispatchClientLocation(val.client);
        }, 500);
      }
    }

    if (!formatedData.length) {
      // this.addAssignTimesheet();
    }

    setTimeout(() => {
      this._assignTimesheetForm.get('assignTimesheets').patchValue(formatedData);
      this.setOptions();
    }, 200);
  }

  /**
 * Callback to handle the responsea of get by employee id
 */
  setEmployeeClientLocationData(data) {
    this.loading.set(false);
    this.assignTimesheetData = data || [];
    this.setAssignClientLocationData();
  }

  // ----------------- Begin: Dispatch --------------- //

  /**
  * Dispatch client lookup
  */
  dispatchClient(id) {
    setTimeout(() => {
      this.subscriptions.push(this.employeeService.getAssignTimeSheetClient(id).subscribe(response => {
      }));
    }, 1000);
  }

  /**
  * Dispatch client-location data by employee id
  */
  dispatchGetAssignLocationByEmployee(id) {
    this.loading.set(true);

    // Need this below API to get client-location by employee id
    this.subscriptions.push(this.employeeService.getAssignTimeSheetClientLocationByEmployee(id).subscribe(response => {
      this.loading.set(false);
      this.setEmployeeClientLocationData(response.data.data.timesheet_employee_client_locations || []);
    }));

    // this.employeeStoreService.dispatchEmployeeCommon({
    //   data: { userId: id },
    //   module: EMPLOYEE_METHOD_CONSTANT.EMPLOYEE_ASSIGN_LOCATION,
    //   method: API_METHOD_CONSTANTS.GET_BY_ID,
    //   callback: this.setEmployeeClientLocationData.bind(this),
    // });
  }

  /**
  * Dispatch location list by client id
  */
  dispatchClientLocation(clientId) {
    this.subscriptions.push(this.employeeService.getAssignTimeSheetClientLocation(this._employeeData.employee_fk_user_id, clientId).subscribe(response => {
      this.lookupOptions.locations[clientId] = of(response.data.data.location);
      // this.setEmployeeClientLocationData(response);

    }));
    // this.clientStoreService.dispatchGetLocationListByClient({ data: { client_id: clientId } });
    // this.lookupOptions.locations[clientId] = this.clientStoreService.selectClientLocationList(clientId);

  }

  // ----------------- End: Dispatch --------------- //

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
